module.exports = __webpack_public_path__ + "static/media/10yrs Warranty.2b3027a1.svg";